var render = function (_h,_vm) {var _c=_vm._c;return _c('label',{staticClass:"badge badge-pill on-hold-status"},[_vm._v(" "+_vm._s(_vm.parent.$it('on-hold.label.title', 'On hold'))+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }